import { ChangeDetectionStrategy, Component, Input } from '@angular/core';


@Component({
    selector: 'app-sidebar-navigation',
    templateUrl: './sidebar-navigation.component.html',
    imports: [],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SidebarNavigationComponent {
  @Input()
  heading = '';
}
